export const FILE_UPLOAD_SUCCESS = 'FILE_UPLOAD_SUCCESS';
export const FILE_UPLOAD_START = 'FILE_UPLOAD_START';
export const FILE_UPLOAD_FAIL = 'FILE_UPLOAD_FAIL';

export const SELECT_FILES = 'SELECT_FILES';
export const SELECT_MANIFEST_FILE = 'SELECT_MANIFEST_FILE';
export const REMOVE_FILE = 'REMOVE_FILE';
export const REMOVE_MANIFEST_FILE = 'REMOVE_MANIFEST_FILE';
